module.exports = __webpack_public_path__ + "4fbac3b5895072134646107d1551b5c0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/cell-phone-s.png
// module id = 2620
// module chunks = 0